const Joi = require('joi')
const fields = require('./fields')

const administrateUserSchema = Joi.object({
    nickname: fields.nicknameField.required(),
    role: fields.roleField.optional(),
    active: fields.boolField.optional().label('Active'),
})

module.exports = administrateUserSchema